import React from 'react'
import PropTypes from 'prop-types'

const SyncIcon = ({ fill, style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#007AFA" fillRule="evenodd" transform="rotate(-180 10 10)">
      <rect width={width} height={height} fillOpacity=".15" rx="2" fill={fill} />
      <path
        fillRule="nonzero"
        d="M10 4.91V3L7.506 5.545 10 8.091V6.18c2.057 0 3.74 1.719 3.74 3.819 0 .636-.186 1.273-.436 1.782l.936.954c.436-.827.748-1.718.748-2.736 0-2.8-2.245-5.09-4.988-5.09zm0 8.908c-2.057 0-3.74-1.718-3.74-3.818 0-.636.186-1.273.436-1.782l-.936-.954c-.436.827-.748 1.718-.748 2.736 0 2.8 2.245 5.09 4.988 5.09V17l2.494-2.545L10 11.909v1.91z"
      />
    </g>
  </svg>
)

SyncIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default SyncIcon
